<template>
  <div style="display: none"></div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { useGoogleTagManagerStore } from '@/stores/google-tag-manager'

const googleTagManagerStore = useGoogleTagManagerStore()

// Tokenized manage links must not reach analytics; entry is always a full page
// load and leaving is a full reload, so a boot-time check covers the visit.
const isTokenizedManagePath = window.location.pathname.startsWith('/manage/reservation/')

try {
  const scriptContent = isTokenizedManagePath ? '' : googleTagManagerStore.getScriptContent()

  if (scriptContent && typeof scriptContent === 'string' && scriptContent.trim()) {
    useHead({
      script: [
        {
          innerHTML: scriptContent,
          key: 'google-tag-manager'
        }
      ]
    })
  }
} catch (error) {
  console.error('Failed to inject Google Tag Manager script:', error)
}
</script>
